import AppHeader from '../AppHeader'

export default {
  name: 'company-notice',
  components: {
    AppHeader
  },
}



// WEBPACK FOOTER //
// ./src/components/scripts/company-notice.js